import { render, staticRenderFns } from "./Archivate.vue?vue&type=template&id=75526831&"
import script from "./Archivate.vue?vue&type=script&lang=js&"
export * from "./Archivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports